import { api } from "./api";

const b64urlToBytes = (v) => {
  const pad = "=".repeat((4 - (v.length % 4)) % 4);
  return Uint8Array.from(atob(v.replace(/-/g, "+").replace(/_/g, "/") + pad), (c) => c.charCodeAt(0));
};
const bytesToB64url = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const passkeySupported = () => typeof window !== "undefined" && !!window.PublicKeyCredential;

const toCreation = (o) => ({ ...o, challenge: b64urlToBytes(o.challenge), user: { ...o.user, id: b64urlToBytes(o.user.id) },
  excludeCredentials: (o.excludeCredentials || []).map((c) => ({ ...c, id: b64urlToBytes(c.id) })) });
const toRequest = (o) => ({ ...o, challenge: b64urlToBytes(o.challenge), allowCredentials: (o.allowCredentials || []).map((c) => ({ ...c, id: b64urlToBytes(c.id) })) });

const credentialJSON = (cred) => {
  const r = cred.response;
  const out = { id: cred.id, rawId: bytesToB64url(cred.rawId), type: cred.type, clientExtensionResults: cred.getClientExtensionResults(), response: {} };
  if ("attestationObject" in r) out.response = { clientDataJSON: bytesToB64url(r.clientDataJSON), attestationObject: bytesToB64url(r.attestationObject), transports: r.getTransports?.() ?? [] };
  else out.response = { clientDataJSON: bytesToB64url(r.clientDataJSON), authenticatorData: bytesToB64url(r.authenticatorData), signature: bytesToB64url(r.signature), userHandle: r.userHandle ? bytesToB64url(r.userHandle) : null };
  return out;
};

/* Real WebAuthn ceremony: server challenge → authenticator → server verification. */
export async function registerPasskey(label) {
  if (!passkeySupported()) throw new Error("This browser does not support passkeys");
  const { data: options } = await api.post("/ceo/webauthn/register/options");
  const cred = await navigator.credentials.create({ publicKey: toCreation(options) });
  if (!cred) throw new Error("Passkey creation was cancelled");
  return (await api.post("/ceo/webauthn/register/verify", { credential: credentialJSON(cred), label })).data;
}

export async function assertPasskey(optionsPath, verifyPath) {
  if (!passkeySupported()) throw new Error("This browser does not support passkeys");
  const { data: options } = await api.post(optionsPath);
  const cred = await navigator.credentials.get({ publicKey: toRequest(options) });
  if (!cred) throw new Error("Passkey verification was cancelled");
  return (await api.post(verifyPath, { credential: credentialJSON(cred) })).data;
}
